var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":_vm.$t('deleteGrpContacts'),"hint":_vm.$t('deleteGrpContactsHint'),"disabled":_vm.disabled,"persistent-hint":"","data-testid":"deleteContactsCheckBoxGroupDetails"},on:{"change":_vm.emitChange},model:{value:(_vm.deleteContacts),callback:function ($$v) {_vm.deleteContacts=$$v},expression:"deleteContacts"}})
}
var staticRenderFns = []

export { render, staticRenderFns }